import * as React from 'react';
import { Car16 } from '@cian/ui-kit/icons';
import { InlineText2 } from '@cian/ui-kit/typography';
import { IGeoRoadInfoSchema } from '../../repositories/newbuilding-card/entities/geo/GeoRoadInfoSchema';
import * as styles from './Roads.css';

interface IRoadsProps {
  roads: IGeoRoadInfoSchema[];
}

export function Roads({ roads }: IRoadsProps) {
  return (
    <>
      {roads
        .filter(road => road.distance)
        .map(roadItem => (
          <div className={styles['road']} key={`${roadItem.name}`}>
            <div className={styles['road-icon']}>
              <Car16 color={'gray_icons_100'} />
            </div>
            <InlineText2>{`${roadItem.name}, ${roadItem.distance} км от МКАД`}</InlineText2>
          </div>
        ))}
    </>
  );
}
